/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { combineReducers } from 'redux';
import { makeAsyncSelectors } from 'ui-permit/shared-components/utils/async';
import availability, { selectors as availabilitySelectors } from './availability';
import reservation, { selectors as reservationSelectors } from './reservation';
import {
    lottery,
    lotteries,
    lotteryIssuance,
    lotteryIssuanceCancel,
    lotteryIssuanceAccept,
    selectors as lotterySelectors,
} from './lottery';
import seasons, { selectors as seasonSelectors } from './season';
import permit, { recarea, selectors as permitSelectors } from './permit';
import validations, { selectors as validationsSelectors } from './validations';
import shared, { selectors as sharedSelectors } from './shared';

// Generate the async selectors
const { isLoaded, isLoading, hasErrors, getErrors } = makeAsyncSelectors('huntingpermit');

// All of our Redux selectors
export {
    getErrors,
    hasErrors,
    isLoaded,
    isLoading,
    availabilitySelectors,
    permitSelectors,
    reservationSelectors,
    lotterySelectors,
    seasonSelectors,
    validationsSelectors,
    sharedSelectors,
};

const reducers = combineReducers({
    availability,
    reservation,
    validations,
    permit,
    recarea,
    lotteries,
    lottery,
    lotteryIssuance,
    lotteryIssuanceCancel,
    lotteryIssuanceAccept,
    seasons,
    shared,
});

export default reducers;
